module.exports = __webpack_public_path__ + "c90ddf19875094dca51a59fb6309aa90.pdf";